import { defineRoutes } from '../utils';

const BASE = '/auth';

/**
 * Auth domain routes — all public (no auth required).
 */
export const authRoutes = defineRoutes({
  auth_register: {
    path: `${BASE}/register`,
    isPublic: true,
  },
  auth_verify_otp: {
    path: `${BASE}/verify-otp`,
    isPublic: true,
  },
  auth_choose_person: {
    path: `${BASE}/choose-person`,
    isPublic: true,
  },
  auth_verified: {
    path: `${BASE}/verified`,
    isPublic: true,
  },
  auth_unauthorized: {
    path: `${BASE}/unauthorized`,
    isPublic: true,
  },
  account_blocked: {
    path: '/account-blocked',
    isPublic: true,
    // Optional-key form (`{ phone?: string }`) — NOT `{ phone: string | undefined }`.
    // The former lets `{}` satisfy the constraint, so `RouteRestArgs` widens
    // to `[params?]` and callers can write `navigate('account_blocked')`
    // without passing a phone. The latter makes the key required and forces
    // every call site to pass `{ phone: … }`. See `navigation/utils/route.ts`
    // for the conditional that gates this.
    params: {} as { phone?: string },
  },
  org_blocked: {
    path: '/org-blocked',
    isPublic: false,
    params: {} as { orgName?: string },
  },
});
